import React, { useRef, useEffect } from 'react';
import { Calendar, Trophy } from 'lucide-react';
import { getYearsFrom2022 } from '../utils/scoreUtils';
import { ToggleGroup, ToggleGroupItem } from './ui/toggle-group';

function YearPillsRow({ setYear, year }) {
  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current && scrollRef.current) {
      const container = scrollRef.current;
      const pill = activeRef.current;
      const offset = pill.offsetLeft - container.offsetWidth / 2 + pill.offsetWidth / 2;
      container.scrollTo({ left: offset, behavior: 'smooth' });
    }
  }, [year]);

  const handleYearChange = (selectedYear) => {
    setYear(selectedYear);
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('year', selectedYear);
    window.history.pushState({}, '', newUrl);
  };

  return (
    <div className="mt-3 mb-3">
      <div className="hidden sm:flex items-center gap-2 mb-3">
        <Calendar className="w-4 h-4 text-primary" />
        <span className="text-sm font-semibold text-primary tracking-wide">TEMPORADAS NFL</span>
        <div className="flex-1 h-px bg-gradient-to-r from-primary/30 to-transparent" />
      </div>

      <div className="relative -mx-4 px-4">
        {/* The scroll edge is faded with a mask rather than an opaque gradient
            overlay. The band behind this row is translucent, and opaque again
            under prefers-reduced-transparency, so no painted colour can match
            it in every case; a mask fades whatever is actually behind. */}
        <div
          ref={scrollRef}
          className="overflow-x-auto scrollbar-hide [-webkit-mask-image:linear-gradient(to_left,transparent,#000_2rem)] [mask-image:linear-gradient(to_left,transparent,#000_2rem)] sm:[-webkit-mask-image:none] sm:[mask-image:none]"
        >
          <ToggleGroup
            type="single"
            value={year.toString()}
            onValueChange={(value) => value && handleYearChange(parseInt(value))}
            className="justify-start gap-2 sm:gap-3 w-max"
          >
            {getYearsFrom2022().slice().reverse().map((yearOption) => (
              <div
                key={yearOption}
                ref={yearOption === year ? activeRef : undefined}
              >
                <ToggleGroupItem
                  value={yearOption.toString()}
                  aria-label={`Select year ${yearOption}`}
                  className="relative px-3 py-1.5 sm:px-4 sm:py-2 text-sm sm:text-base font-bold transition-[color,background-color,border-color,box-shadow,transform] duration-fast ease-out active:scale-[0.97] motion-reduce:active:scale-100 border border-primary/20 [@media(hover:hover)_and_(pointer:fine)]:hover:border-primary/40 [@media(hover:hover)_and_(pointer:fine)]:hover:shadow-md data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:shadow-lg data-[state=on]:shadow-primary/25 rounded-xl"
                >
                  <div className="flex items-center gap-2">
                    {year === yearOption && <Trophy className="w-3 h-3" />}
                    <span>{yearOption}</span>
                  </div>
                </ToggleGroupItem>
              </div>
            ))}
          </ToggleGroup>
        </div>
      </div>
    </div>
  );
}

export default YearPillsRow;
